const filterRedirectInit = function(){
	const filters = document.querySelectorAll('.filter__select');
	if( filters ){
		filters.forEach(e => {
			e.addEventListener('change', changeEvent =>{
				if(changeEvent.target.value){
					window.location = changeEvent.target.value;
				}
			})
		});
	}
}

export default filterRedirectInit;